import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import "./FlightDoNotClose.css";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../../config";

const FlightDoNotClose = () => {
  const { bookingId } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [params] = useSearchParams();

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const blockBack = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", blockBack);
    return () => window.removeEventListener("popstate", blockBack);
  }, []);

  // ⚠️ WARN ON TAB CLOSE / REFRESH
  useEffect(() => {
    const warnUser = (e) => {
      e.preventDefault();
      e.returnValue =
        "Booking in progress. Closing this page may result in payment issues.";
    };
    window.addEventListener("beforeunload", warnUser);
    return () => window.removeEventListener("beforeunload", warnUser);
  }, []);

  useEffect(() => {
  let isMounted = true;

  const pollBooking = async () => {
    try {
        const sessionId = params.get("session_id");
		const res = await axios.post(`${BASE_URL}Tripjack/book-flight`, {
		  bookingId: bookingId,
		  sessionId: sessionId,
		});
     
		
		const bookingStatus = res.data.data.status;
    const bookingMessage = res.data.data.message;
console.log(res.data.data.status);
    //  if (!isMounted) return;

      if (bookingStatus  === "CONFIRMED") {
        navigate(`/flight-ticket/${res.data.data.provider_booking_id}`);
        return;
      }else{
          const bookingmsg = res.data.data.message;
          Swal.fire({
			icon: "error",
			title: "Booking Failed",
			html: `
			<ol style="text-align: left; padding-left: 1.2rem; list-style: disc; font-size: 14px;">
			  <li>We're sorry, your booking could not be completed.</li>
			  <li>${bookingmsg}</li>
			  <li>If any amount was deducted, it will be refunded within <strong>5–7 business days</strong>.</li>
			  <li>Contact support at <strong><a href="tel:+966 58 085 8030">+966 58 085 8030</a></strong></li>
			</ol>
			${bookingMessage}
		  `,
		  });
		  navigate("/");
        return;
      }

     
      /* if (data.success === "PENDING") {
        setStep((prev) => (prev < 4 ? prev + 1 : prev));
      } */
    } catch (err) {
        const errorMessage =
    err?.response?.data?.message ||   // API error message
    err?.message ||                   // JS / Axios error
    "Something went wrong. Please try again.";
      Swal.fire({
        icon: "error",
        title: "Booking Failed",
        html: `
        <ol style="text-align: left; padding-left: 1.2rem; list-style: disc; font-size: 14px;">
          <li>We're sorry, your booking could not be completed.</li>
          <li><strong>Error:</strong> ${Swal.escapeHtml(errorMessage)}</li>
          <li>If any amount was deducted, it will be refunded within <strong>5–7 business days</strong>.</li>
          <li>Contact support at <strong><a href="tel:+966 58 085 8030">+966 58 085 8030</a></strong></li>
        </ol>
      `,
      });
      navigate("/");
    }
  };

  // First call immediately
  pollBooking();

  // Poll every 4 seconds
  //const interval = setInterval(pollBooking, 4000);

  return () => {
    //isMounted = false;
    //clearInterval(interval);
  };
}, [bookingId, navigate]);

  return (
    <div className="do-not-close-container">
      <div className="card">
        <h1>✈️ Booking Your Flight</h1>
        <p className="subtitle">
          Please do <strong>NOT</strong> close or refresh this page
        </p>

       
        <div className="loader"></div>

        <div className="warning-box">
          ⚠️ Closing this page may cause <strong>payment loss</strong> or
          <strong> incomplete booking</strong>.
        </div>
      </div>
    </div>
  );
};

const ProgressStep = ({ active, text }) => (
  <div className={`step ${active ? "active" : ""}`}>
    <span className="dot" />
    <span>{text}</span>
  </div>
);

export default FlightDoNotClose;
